// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"670abc09","633":"e677723b"}[chunkId] + ".chunk.js";
};